import ControlPointIcon from '@mui/icons-material/ControlPoint';
import {
    Box,
    Chip,
    Menu,
    MenuItem,
} from '@mui/material';
import {useState} from 'react';
import {
    useGetList,
    useRecordContext, useRefresh,
    useUpdate,
} from 'react-admin';


export const UserRoleEdit = () => {
    const [user, setUser] = useState(useRecordContext())

    const [anchorEl, setAnchorEl] = useState(null);

    const {data: allRoles, isLoading: isLoadingAllRoles} =
        useGetList('user/roles');
    const roles = user.roles;
    const [update] = useUpdate();
    const refresh = useRefresh();
    const unselectedRoles =
        allRoles && allRoles.filter(role => !user.roles.includes(role.name));

    const handleOpen = event => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleDeleteRole = name => {
        const roles = user.roles.filter(roleName => roleName !== name);
        update(`admin/user/roles`, {
            id: user.id,
            data: {roles},
            previousData: user,
        }, {
            onSuccess: (user) => {
                setUser(user);
                refresh();
            }}
        );
    };

    const handleAddRole = name => {
        const roles = [...user.roles, name];
        update(`admin/user/roles`, {
            id: user.id,
            data: {roles},
            previousData: user,
            }, {
                onSuccess: (user) => {
                    setUser(user);
                    refresh();
                }}
        );
        setAnchorEl(null);
    };

    if (!roles || isLoadingAllRoles) return null;
    return (
        <>
            {roles.map(role => (
                <Box mt={1} mb={1} key={role}>
                    <Chip
                        size="small"
                        variant="outlined"
                        onDelete={() => handleDeleteRole(role)}
                        label={role}
                        style={{border: 0}}
                    />
                </Box>
            ))}
            <Box mt={1}>
                <Chip
                    icon={<ControlPointIcon/>}
                    size="small"
                    variant="outlined"
                    onClick={handleOpen}
                    label="Add role"
                    color="primary"
                />
            </Box>
            <Menu
                open={Boolean(anchorEl)}
                onClose={handleClose}
                anchorEl={anchorEl}
            >
                {unselectedRoles?.map(role => (
                    <MenuItem key={role.name} onClick={() => handleAddRole(role.name)}>
                        <Chip
                            size="small"
                            variant="outlined"
                            label={role.name}
                            style={{border: 0}}
                            onClick={() => handleAddRole(role.name)}
                        />
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
};
